import { viewSchemas } from "@redotech/redo-model/views/views";
import { z } from "zod";

export const saveView = {
  input: z.object({ view: viewSchemas["fulfillment-groups"] }),
  output: z.object({}),
};
